import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalConfig } from "./authConfig";

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Handle MSAL initialization and redirect flow
(async () => {
  try {
    await msalInstance.initialize(); // ✅ REQUIRED as of MSAL v4+
    await msalInstance.handleRedirectPromise(); // ✅ Safe to call after init

    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      // You can wrap in <React.StrictMode> again after it's working
      <MsalProvider instance={msalInstance}>
        <Router>
          <Routes>
            <Route path="/" element={<App />} />
          </Routes>
        </Router>
      </MsalProvider>
    );
  } catch (error) {
    console.error("❌ MSAL redirect handling error:", error);
  }
})();
